<div #legendContainerEl></div>
